import axios from "axios";
import { clearAllCookies, getCookie } from "../utils/cookie";
import { USER_COOKIE } from "../context/AuthContext";
const baseUrl = process.env.REACT_APP_API_BASEURL;
const domain = process.env.REACT_APP_API_DOMAIN;
const appId = process.env.REACT_APP_API_APPID;
const version = process.env.REACT_APP_API_VERSION;

const apiClient = axios.create({
  baseURL: baseUrl,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    AppID: appId,
    Version: version,
    Domain: domain,
  },
});

const logoutToLogin = () => {
  clearAllCookies();
  window.location.replace("/login");
};

// Every API after login needs UserID / SessionID / Session in headers
apiClient.interceptors.request.use((config) => {
  const user = getCookie(USER_COOKIE);
  if (user) {
    config.headers.UserID = user.userID;
    config.headers.SessionID = user.sessionID;
    config.headers.Session = user.session;
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => {
    // API sends expired/invalid session as HTTP 200 + statuscode -1
    const { statuscode, msg } = response.data || {};
    if (statuscode === -1 && /session/i.test(msg || "")) {
      logoutToLogin();
    }
    return response.data;
  },
  (error) => {
    const status = error.response?.status;
    const isLoginRequest = error.config?.url?.includes("/Login");
    if (status === 401 && !isLoginRequest) {
      logoutToLogin();
    }
    return Promise.reject(error);
  },
);

export default apiClient;
